<template>
  <div class="ine-card skill-dive-session-item" @click="goToLab">
    <div class="skill-dive-session-item__detail-wrapper">
      <div class="skill-dive-session-item__name">
        {{ sessionItem.lab.name }}
      </div>
      <div class="skill-dive-session-item__learning_container">
        <div class="skill-dive-session-item__learning_container--item">
          <div
            :class="[
              'skill-dive-session-item__ellipsis',
              `skill-dive-session-item__${sessionItem.lab.learning_area.slug}`,
            ]"
          />
          {{ sessionItem.lab.learning_area.name }}
        </div>
        <div class="skill-dive-session-item__learning_container--item">
          {{ sessionItem.lab.difficulty }}
        </div>
      </div>
    </div>
    <div class="skill-dive-session-item__time">
      Time spent:
      <span>{{ timeSpentFormatted(sessionItem.duration_in_seconds) }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SkillDiveSessionItem',
  props: {
    sessionItem: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goToLab() {
      this.$router.push({
        name: 'lab-page',
        params: { labId: this.sessionItem.lab.id },
      })
    },
    timeSpentFormatted(value) {
      const timeFormatted = value
        ? this.$duration.durationOn(this.$duration.hhmmss(value, 'HOURSMIN'))
        : 0
      return timeFormatted
    },
  },
}
</script>
<style lang="scss" scoped>
.skill-dive-session-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  color: var(--white);
  font-weight: 450;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid var(--glass-mid-gray, #3e3f49);
  background: var(
    --glass-mid-gray,
    linear-gradient(
      105deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    )
  );
  &:hover {
    border: 1px solid var(--glass-extra-light, rgba(187, 188, 199, 0.4));
    background: var(
      --glass-extra-light,
      linear-gradient(
        112deg,
        rgba(187, 188, 199, 0.4) -46.39%,
        rgba(187, 188, 199, 0) 112.38%
      )
    );
  }

  &__detail-wrapper {
    @include mobile {
      min-width: 520px;
    }
  }

  &__name {
    font-size: 14px;
    line-height: 20px;
  }

  &__learning_container {
    display: flex;
    margin-top: 5px;

    &--item {
      display: flex;
      align-items: center;
      gap: 5px;
      text-transform: capitalize;
      &:not(:last-child) {
        border-right: 1px solid var(--perfect-gray);
        padding-right: 10px;
      }
      &:nth-child(2) {
        margin-left: 10px;
      }
      @include mobile {
        &:not(:last-child) {
          border-right: 1px solid var(--perfect-gray);
          border-bottom: none;
          padding-right: 10px;
        }
      }
    }
  }

  &__time {
    font-size: 12px;
    line-height: 14px;
    color: var(--light-blue-gray);

    span {
      color: var(--white);
    }
  }

  &__ellipsis {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  &__cloud {
    background-color: var(--larea-cloud);
  }

  &__cyber-security {
    background-color: var(--larea-cyber-security);
  }

  &__networking {
    background-color: var(--larea-networking);
  }
}
</style>
